import useEventListener from '@use-it/event-listener';

const VIEWS_UNTIL_COLLAPSED = 3;

interface Args {
  isConnected: boolean;
  hasSettings: boolean;
  pageShortName: string;
}

export function useIsFitnessSectionExpanded({
  isConnected,
  hasSettings,
  pageShortName,
}: Args): boolean {
  const state = isConnected && hasSettings ? 'connect' : 'disconnect';

  const isExpanded = localStorage.getItem(
    `strava.CTAisExpanded-${pageShortName}`,
  );

  const viewCount =
    Number(localStorage.getItem(`strava.${state}ViewCount-${pageShortName}`)) ??
    0;

  useEventListener('unload', () => {
    if (viewCount <= VIEWS_UNTIL_COLLAPSED) {
      localStorage.setItem(
        `strava.${state}ViewCount-${pageShortName}`,
        String(viewCount + 1),
      );
    }
  });

  if (isExpanded) {
    return JSON.parse(isExpanded);
  }
  return VIEWS_UNTIL_COLLAPSED > viewCount;
}
